<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { Button } from '@/components/ui/button'
import { AlertTriangle, RefreshCw } from 'lucide-vue-next'
import { HOST } from '@/utils/http'

const isRetrying = ref(false)
const retryFailed = ref(false)

const handleRetry = async () => {
  isRetrying.value = true
  retryFailed.value = false

  try {
    await axios.get(`${HOST}/front-config`)
    window.location.href = '/'
  } catch (error) {
    retryFailed.value = true
    isRetrying.value = false
  }
}
</script>

<template>
  <div class="h-screen w-screen bg-gray-50 flex items-center justify-center p-8">
    <div class="max-w-md w-full text-center space-y-6">
      <div class="flex justify-center">
        <div class="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center">
          <AlertTriangle class="w-10 h-10 text-red-600" />
        </div>
      </div>

      <div class="space-y-2">
        <h1 class="text-2xl font-bold text-gray-900">
          Unable to Connect
        </h1>
        <p class="text-gray-600">
          We're having trouble connecting to our servers. This could be a temporary issue.
        </p>
      </div>

      <div class="pt-4">
        <Button
          @click="handleRetry"
          :disabled="isRetrying"
          class="min-w-[200px]"
        >
          <RefreshCw
            v-if="isRetrying"
            class="w-4 h-4 mr-2 animate-spin"
          />
          <span v-if="isRetrying">Retrying...</span>
          <span v-else>Try Again</span>
        </Button>
      </div>

      <p class="text-sm text-gray-500">
        <span v-if="retryFailed" class="text-red-500">Connection still unavailable. </span>
        If this problem persists, please try again later.
      </p>
    </div>
  </div>
</template>
